// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Card Styles */
.card-ui {
  border-radius: var(--radius-xl);
  transition: all var(--transition-base);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Card Variants */
.card-glass {
  background: var(--glass-bg-strong);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-md);
}

.card-solid {
  background: var(--color-dark-lighter);
  border: 1px solid var(--color-dark-light);
  box-shadow: var(--shadow-lg);
}

.card-outlined {
  background: transparent;
  border: 2px solid var(--glass-border-strong);
}

.card-default {
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(5px);
}

/* Card Padding */
.card-padding-none {
  padding: 0;
}

.card-padding-sm {
  padding: var(--space-md);
}

.card-padding-md {
  padding: var(--space-lg);
}

.card-padding-lg {
  padding: var(--space-xl);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  /* Card States */
  .card-hoverable:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-xl);
    border-color: var(--glass-border-strong);
  }
}


.card-clickable {
  cursor: pointer;
}

.card-clickable:active {
  transform: translateY(-2px);
}

/* Card Sub-components */
.card-header {
  padding: var(--space-lg);
  border-bottom: 1px solid var(--glass-border);
}

.card-body {
  padding: var(--space-lg);
  flex: 1 1;
}

.card-footer {
  padding: var(--space-lg);
  border-top: 1px solid var(--glass-border);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-md);
}

/* When using sub-components, remove default padding */
.card-ui:has(.card-header, .card-body, .card-footer) {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Card.css"],"names":[],"mappings":"AAEA,qBAAqB;AACrB;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;sEACsE;AACtE;EACE,gBAAgB;EAChB;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,wCAAwC;EAC1C;AACF;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;EACE,UAAU;AACZ","sourcesContent":["@import '../../styles/variables.css';\n\n/* Base Card Styles */\n.card-ui {\n  border-radius: var(--radius-xl);\n  transition: all var(--transition-base);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Card Variants */\n.card-glass {\n  background: var(--glass-bg-strong);\n  border: 1px solid var(--glass-border);\n  backdrop-filter: blur(10px);\n  box-shadow: var(--shadow-md);\n}\n\n.card-solid {\n  background: var(--color-dark-lighter);\n  border: 1px solid var(--color-dark-light);\n  box-shadow: var(--shadow-lg);\n}\n\n.card-outlined {\n  background: transparent;\n  border: 2px solid var(--glass-border-strong);\n}\n\n.card-default {\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  backdrop-filter: blur(5px);\n}\n\n/* Card Padding */\n.card-padding-none {\n  padding: 0;\n}\n\n.card-padding-sm {\n  padding: var(--space-md);\n}\n\n.card-padding-md {\n  padding: var(--space-lg);\n}\n\n.card-padding-lg {\n  padding: var(--space-xl);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  /* Card States */\n  .card-hoverable:hover {\n    transform: translateY(-4px);\n    box-shadow: var(--shadow-xl);\n    border-color: var(--glass-border-strong);\n  }\n}\n\n\n.card-clickable {\n  cursor: pointer;\n}\n\n.card-clickable:active {\n  transform: translateY(-2px);\n}\n\n/* Card Sub-components */\n.card-header {\n  padding: var(--space-lg);\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.card-body {\n  padding: var(--space-lg);\n  flex: 1;\n}\n\n.card-footer {\n  padding: var(--space-lg);\n  border-top: 1px solid var(--glass-border);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--space-md);\n}\n\n/* When using sub-components, remove default padding */\n.card-ui:has(.card-header, .card-body, .card-footer) {\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
